// Shared calendar-aligned duration filters for the SC Portal (New Requests +
// Service Requests), so both views filter the same way — This Month / This
// Quarter / This Financial Year (Apr–Mar, India) / All Time.

export const DURATION_FILTERS = [
  { v: "this_month", label: "This Month" },
  { v: "this_quarter", label: "This Quarter" },
  { v: "this_fy", label: "This FY" },
  { v: "all", label: "All Time" },
];

function fyStartYear(d) {
  // Indian financial year runs Apr 1 → Mar 31. If we're in Jan/Feb/Mar, the FY
  // started the previous calendar year.
  return d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
}

export function inDurationWindow(iso, filter) {
  if (!iso || filter === "all") return true;
  const d = new Date(iso);
  const now = new Date();
  if (filter === "this_month") {
    return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
  }
  if (filter === "this_quarter") {
    const q = (x) => Math.floor(x.getMonth() / 3);
    return d.getFullYear() === now.getFullYear() && q(d) === q(now);
  }
  if (filter === "this_fy") {
    return fyStartYear(d) === fyStartYear(now);
  }
  return true;
}
